import './Continue.scss';
import Component from './Continue.js';
export default Component;
